import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useTheme } from '../context/ThemeContext'
import { useLocation } from 'react-router-dom'
import UserProfileDropdown from './UserProfileDropdown'

export default function Navigation() {
  const { user, logout } = useAuth()
  const { theme, toggleTheme } = useTheme()
  const location = useLocation()

  // Determine if we're on an app page (dashboard, profile, etc.) vs marketing page
  const isAppPage = user && (
    location.pathname.startsWith('/dashboard') ||
    location.pathname.startsWith('/profile') ||
    location.pathname.startsWith('/jobs')
  )

  // Function to trigger modals - will be called from HomePage
  const handleLogin = () => {
    // Dispatch event that HomePage listens for
    if (location.pathname === '/') {
      window.dispatchEvent(new CustomEvent('openLoginModal'))
    } else {
      window.location.href = '/dashboard'
    }
  }

  const handleSignup = () => {
    // Dispatch event that HomePage listens for
    if (location.pathname === '/') {
      window.dispatchEvent(new CustomEvent('openSignupModal'))
    } else {
      window.location.href = '/'
    }
  }

  return (
    <nav className="sticky top-0 z-40 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="text-2xl font-bold text-primary-600 dark:text-primary-400">
            ContentIndexer
          </Link>

          {/* Navigation Links - Different for marketing vs app pages */}
          <div className="hidden md:flex items-center gap-8">
            {isAppPage ? (
              // App Navigation (when logged in and on dashboard/profile)
              <>
                <Link
                  to="/dashboard"
                  className={`text-gray-700 dark:text-gray-300 hover:text-primary-600 transition ${
                    location.pathname === '/dashboard' ? 'text-primary-600 dark:text-primary-400 font-semibold' : ''
                  }`}
                >
                  Dashboard
                </Link>
                <Link
                  to="/profile"
                  className={`text-gray-700 dark:text-gray-300 hover:text-primary-600 transition ${
                    location.pathname === '/profile' ? 'text-primary-600 dark:text-primary-400 font-semibold' : ''
                  }`}
                >
                  Profile
                </Link>
                <a
                  href="/openapi.yaml"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 dark:text-gray-300 hover:text-primary-600 transition"
                >
                  API Docs
                </a>
              </>
            ) : (
              // Marketing Navigation (home page or not logged in)
              <>
                <a href="#pricing" className="text-gray-700 dark:text-gray-300 hover:text-primary-600 transition">
                  Pricing
                </a>
                <a href="#calculator" className="text-gray-700 dark:text-gray-300 hover:text-primary-600 transition">
                  Calculator
                </a>
                <Link
                  to="/docs/developer"
                  className="text-gray-700 dark:text-gray-300 hover:text-primary-600 transition"
                >
                  Developer Docs
                </Link>
              </>
            )}
          </div>

          {/* Right Actions */}
          <div className="flex items-center gap-4">
            {/* Theme Toggle */}
            <button
              onClick={toggleTheme}
              className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition"
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? (
                <i className="fas fa-sun text-yellow-500"></i>
              ) : (
                <i className="fas fa-moon text-gray-400"></i>
              )}
            </button>

            {/* Auth Buttons */}
            {!user ? (
              <div className="flex items-center gap-2">
                <button
                  onClick={handleLogin}
                  className="px-4 py-2 text-primary-600 hover:text-primary-700 font-medium cursor-pointer"
                >
                  Login
                </button>
                <button
                  onClick={handleSignup}
                  className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 font-medium cursor-pointer"
                >
                  Sign Up
                </button>
              </div>
            ) : (
              <UserProfileDropdown user={user} logout={logout} />
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}
